import React from 'react'
import Iframe from 'react-iframe'

export const Blueprint3d = () => {
    // overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:150%;width:150%;position:absolute;top:0px;left:0px;right:0px;bottom:0px
    const url = "https://furnishup.github.io/blueprint3d/example";
    return (
        <Iframe url={url}
        width="100%"
        height="100%"       
        position="relative"></Iframe>
    )
}
